import { renderToStaticMarkup } from "react-dom/server";
import Person from "@mui/icons-material/Person";
import DirectionsCar from "@mui/icons-material/DirectionsCar";
import Home from "@mui/icons-material/Home";
import Place from "@mui/icons-material/Place";
import { WebMarkerInput } from "./types";

function renderIconString(key: WebMarkerInput['icon']): string {
    switch (key) {
      case "car":
        return renderToStaticMarkup(<DirectionsCar />);
      case "place":
        return renderToStaticMarkup(<Place />);
      case "person":
        return renderToStaticMarkup(<Person />);
      case "house":
        return renderToStaticMarkup(<Home />);
      default:
        return "";
    }
  }
  
  export function createIconLookupTable(iconKeys: WebMarkerInput['icon'][]): Map<WebMarkerInput['icon'], string> {
    const lookupTable = new Map<WebMarkerInput['icon'], string>();
    const uniqueIconKeys = new Set(iconKeys);
  
    uniqueIconKeys.forEach((str) => {
      lookupTable.set(str, renderIconString(str));
    });
  
    return lookupTable;
  }